import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-label="The 6 volumes" data-id="element-302" data-mp="cnzejh26v1e0">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-303" data-mp="7qpoq0aw0npn">
        <SectionHeading title={<>
              Everything you need to build a <span className="text-volt" data-id="element-305" data-mp="3c3ml2k015v0n">repeatable workflow</span>
            </>} sub="Your complete 6-volume professional blueprint." data-id="element-304" data-mp="3g4ycmv2gsqbh" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-306" data-mp="3pwc6am7qivwp">
          {volumes.map((v, i) => <article key={v.title} className="flex flex-col rounded-2xl border border-line bg-ink p-5 sm:p-7" data-id="element-307" data-mp="3l2rdr9owuu4w" data-mpi={i}>
              <span className="inline-flex w-fit rounded-md bg-volt px-2.5 py-1 font-display text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-308" data-mp="2xcnd9b70rai4">
                Volume {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 font-display text-[28px] font-extrabold uppercase leading-[1] text-white sm:text-3xl" data-id="element-309" data-mp="2eebrwl4chv4x">
                {v.title}
              </h3>
              <p className="mt-2 text-base text-mist" data-id="element-310" data-mp="2j63hasbrluth">{v.tagline}</p>
              <ul className="mt-5 grid gap-2.5" data-id="element-311" data-mp="2o3d92emmmikh">
                {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-medium text-white" data-id="element-312" data-mp="1qho84mfbe6q2">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-313" data-mp="1vgintfhzjf5y" />
                    {item}
                  </li>)}
              </ul>
              <div className="mt-auto pt-6" data-id="element-314" data-mp="24hgxadb70evx">
                <div className="flex items-start gap-3 rounded-xl bg-spark/10 px-4 py-3" data-id="element-315" data-mp="24e2skyf23tlb">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-spark" aria-hidden="true" data-id="element-316" data-mp="3bw21oaf0l3rt" />
                  <p className="text-sm text-white" data-id="element-317" data-mp="3fxnlygtvokc1">
                    <span className="font-bold text-spark" data-id="element-318" data-mp="1gprlipw6fbgo">Your practical outcome: </span>
                    {v.outcome}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Get all 6 volumes now" data-id="element-319" data-mp="1pqprhdq6dt1w" />
      </div>
    </section>;
}